export default __webpack_public_path__ + "static/media/face-share.67204345.svg";